var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashiconsTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5H18.75C19.5 5 20 5.5 20 6.25V7.5H3.75V6.25C3.75 5.5 4.375 5 5 5H8.75C9 3.625 10.375 2.5 11.875 2.5C13.375 2.5 14.75 3.625 15 5ZM10 5H13.75C13.5 4.25 12.625 3.75 11.875 3.75C11.125 3.75 10.25 4.25 10 5ZM5 8.75H18.75L17.625 21.375C17.625 22 17 22.5 16.375 22.5H7.375C6.75 22.5 6.25 22 6.125 21.375L5 8.75Z",
    fill: "#8BAEC3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashiconsTrash);
export default __webpack_public_path__ + "static/media/dashicons-trash.90c49b6b972a447733ef148d9a90f29b.svg";
export { ForwardRef as ReactComponent };